export function LogoMark({ className = "h-11 w-11" }) {
  return <img src="/images/logo-aplusglass.png" alt="Logo A+ Glass Vitrage Automobile" className={`${className} object-contain`} width="226" height="226" />;
}

export function Logo({ light = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark />
      <span className="leading-none">
        <span className={`block font-display text-[1.05rem] font-extrabold tracking-tight ${light ? "text-white" : "text-ag-ink"}`}>A+GLASS</span>
        <span className={`block text-[0.68rem] font-semibold uppercase tracking-[0.18em] ${light ? "text-blue-200" : "text-ag-blue"}`}>Pare-Brise Haguenau</span>
      </span>
    </span>
  );
}
